import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { SharingsDataService, SharingsColumnsService } from '../../../services';
import { Sharing, SharingsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-sharing-details',
  templateUrl: './sharing-details.component.html',
  styleUrls: ['./sharing-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SharingDetailsComponent implements OnInit, OnDestroy {

  public sharing: Sharing = {};
  public sharings: Sharing[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private sharingsDataService: SharingsDataService,
    private sharingsColumnsService: SharingsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Sharing - Details');
        this.getSharing(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.sharing !== 'undefined') {
      this.sharing = this.dynamicDialogConfig.data.sharing;
    }
    this.columns = this.sharingsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getSharing(id: number): void {
    this.isLoading = true;
    this.sharingsDataService.getSharing(id).subscribe((response: Sharing|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.sharing = response;
      }
    });
  }

  list() {
    this.router.navigate(['/sharings']);
  }

  add() {
    this.router.navigate(['/sharings/add']);
  }

  edit() {
    this.router.navigate(['/sharings/edit/' + this.sharing.id]);
  }

}
@Component({
  selector: 'app-sharing-details',
  templateUrl: './sharing-details.component.html',
  styleUrls: ['./sharing-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSharingDetailsComponent extends SharingDetailsComponent {
}

